export const museFeatureList = [
    'simple-remote-recording',
    'advanced-remote-recording',
    'obs-screen-share',
    'browser-modals',
    'desktop-app-only-feature',
    'browser-default-speaker-output-only',
] as const

export type MuseFeature = (typeof museFeatureList)[number]

export class FeatureFlags {
    static cache: { [key: string]: boolean } = {}

    static isEnabled(feature: MuseFeature): boolean {
        if (museFeatureList.includes(feature)) {
            if (this.cache[feature] != null) {
                return this.cache[feature]
            } else {
                const b = !!localStorage.getItem(this.toLocalStorageKeyName(feature))
                this.cache[feature] = b
                return b
            }
        } else {
            console.error(`FeatureFlags: feature named "${feature}" does not exist! No-op.`)
            return false
        }
    }

    static enable(feature: MuseFeature) {
        if (museFeatureList.includes(feature)) {
            localStorage.setItem(this.toLocalStorageKeyName(feature), '1')
            this.cache[feature] = true
        } else {
            console.error(`FeatureFlags: feature named "${feature}" does not exist! No-op.`)
        }
    }

    static disable(feature: MuseFeature) {
        if (museFeatureList.includes(feature)) {
            localStorage.setItem(this.toLocalStorageKeyName(feature), '')
            this.cache[feature] = false
        } else {
            console.error(`FeatureFlags: feature named "${feature}" does not exist! No-op.`)
        }
    }

    static set(feature: MuseFeature, value: boolean) {
        if (value) {
            this.enable(feature)
        } else {
            this.disable(feature)
        }
    }

    private static toLocalStorageKeyName(feature: string) {
        return `feature.${feature}`
    }
}
